import { initiateBidTransaction } from '../containers/ListingPage/ListingPage.duck';
import { StatusCode } from './enums';
import { createResourceLocatorString } from './routes';
import { showErrorToast, showSuccessToast } from './toast';

export const handleBidTransaction = async params => {
  const { dispatch, history, routeConfiguration, ...rest } = params || {};
  try {
    const response = await dispatch(initiateBidTransaction(rest));
    if (response.statusCode === StatusCode.SUCCESS) {
      showSuccessToast('Successfully submitted bid');

      setTimeout(() => {
        history.push(
          createResourceLocatorString('OrderDetailsPage', routeConfiguration, {
            id: response?.transactionId,
          })
        );
      }, 2000);
    }
  } catch (error) {
    showErrorToast('Error while sending bid ');
  }
};
